import { Component, OnInit } from '@angular/core';
import { NotificationType } from 'src/app/models/notification.message';
import { RoleRequest } from 'src/app/models/requests/role-request';
import { RolesService } from 'src/app/services/roles.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-new-role',
  templateUrl: './new-role.component.html',
  styleUrls: ['./new-role.component.css']
})
export class NewRoleComponent {

  name: string = '';
  description: string = '';


  constructor(private roleService: RolesService, private notification: NotificationService) { }

  
  onSubmit(): void {
    let RoleVm: RoleRequest = {
      roleName: this.name,
      roleDescription: this.description,
    };

    this.roleService.saveRole(RoleVm).subscribe({
      next: (data => {
        
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          console.debug(`Role Created successfully ${data}`);
          this.description = '';
          this.name = ''

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        ;


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });
  }
}
